var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 70,
    viewBox: "0 0 63 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 31,
    r: 20,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5455 22C32.0531 22 30.5943 22.4425 29.3534 23.2716C28.1126 24.1008 27.1455 25.2792 26.5744 26.658C26.0033 28.0367 25.8538 29.5539 26.145 31.0175C26.4361 32.4812 27.1548 33.8257 28.21 34.8809C29.2653 35.9362 30.6098 36.6548 32.0734 36.946C33.5371 37.2371 35.0543 37.0877 36.433 36.5166C37.041 36.2648 37.61 35.9359 38.1273 35.5406L42.2934 39.7066C42.6839 40.0971 43.3171 40.0971 43.7076 39.7066C44.0981 39.3161 44.0981 38.6829 43.7076 38.2924L39.5414 34.1262C39.6379 33.9999 39.7306 33.8703 39.8193 33.7375C40.6484 32.4967 41.091 31.0378 41.091 29.5454C41.0908 27.5443 40.2958 25.6252 38.8808 24.2101C37.4658 22.7951 35.5466 22.0001 33.5455 22ZM37.4666 25.6244C36.4267 24.5844 35.0162 24.0001 33.5455 24C32.4487 24 31.3765 24.3252 30.4646 24.9346C29.5526 25.5439 28.8419 26.41 28.4221 27.4233C28.0024 28.4366 27.8926 29.5516 28.1066 30.6274C28.3205 31.7031 28.8487 32.6912 29.6242 33.4667C30.3998 34.2423 31.3879 34.7704 32.4636 34.9844C33.5393 35.1984 34.6543 35.0886 35.6677 34.6688C36.681 34.2491 37.547 33.5383 38.1564 32.6264C38.7657 31.7145 39.091 30.6423 39.091 29.5455C39.0909 28.0748 38.5066 26.6643 37.4666 25.6244Z",
    fill: "#183254"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.419271 0 0 0 0 0.430012 0 0 0 0 0.4375 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.2e048613898cbcc6467a853d3b4cf927.svg";
export { ForwardRef as ReactComponent };